"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NOOP", {
  enumerable: true,
  get: function () {
    return _empty.NOOP;
  }
});
var _empty = require("@base-ui/utils/empty");